// extracted by mini-css-extract-plugin
export default {"root":"Mu0bmS"};